<template>
  <!-- Table Container Card -->
  <b-card id="page-supports" no-body class="mb-0 p-2">
    <b-card-header class="pl-0 pr-0">
      <b-card-title
        ><h2>{{ $t(label("title")) }}</h2></b-card-title
      >
      <b-button
        v-if="canCreate"
        id="tooltip-create"
        variant="primary"
        @click="onCreate"
      >
        <feather-icon icon="PlusIcon" class="mr-25" />
        <span class="text-nowrap">{{ $t(label("register")) }}</span>
      </b-button>
      <b-tooltip
        placement="top"
        target="tooltip-create"
        triggers="hover"
        @click="onInfo"
      >
        <strong>
          <feather-icon icon="ExternalLinkIcon" class="mr-25 mt-0" />
          Ver tutorial
        </strong>
        <span> </span>
      </b-tooltip>
    </b-card-header>
    <Filterss
      :fields="fieldsToFilters"
      :model="model"
      @filter-applied="applyFilters"
      @filter-reset="resetFilters"
    />
    <!-- table -->
    <b-table
      id="subcriptions-table"
      responsive
      :head-variant="headVariant"
      :striped="striped"
      :bordered="bordered"
      :borderless="borderless"
      :outlined="outlined"
      :per-page="perPage"
      :busy="loading"
      :items="items"
      :fields="fields"
      class="d-none d-md-table shadow-sm !rounded"
    >
      <!-- A custom formatted header cell for field 'name' -->
      <template #head()="data">
        <span class="text-black">{{
          $t(labelHeader(data.label.toLowerCase()))
        }}</span>
      </template>

      <template #cell(nameType)="data">
        <b-badge pill :variant="tagsColor(data.value)">
          {{ data.value }}
        </b-badge>
      </template>

      <template #cell(actions)="data">
        <feather-icon
          class="text-success mr-25"
          size="18"
          icon="FileTextIcon"
          v-if="canShow"
          @click="onShow(data.item.idTicketsSupport)"
        />

        <feather-icon
          class="text-primary mr-25"
          size="18"
          icon="EditIcon"
          v-if="canEdit"
          @click="onEdit(data.item.idTicketsSupport)"
        />

        <feather-icon
          v-if="canDelete"
          class="text-danger"
          size="18"
          icon="Trash2Icon"
          @click="onDelete(data.item.idTicketsSupport)"
        />
      </template>

      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle ml-50"></b-spinner>
          <strong>{{ $t("loading") }}...</strong>
        </div>
      </template>
    </b-table>

    <!-- pagination -->
    <div class="mx-2">
      <b-row>
        <b-col cols="12" sm="12" md="2" lg="2" xl="2" class="mb-2">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">{{
              $t("perPage")
            }}</label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
              @change="handlePerPageChange"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          sm="12"
          md="10"
          lg="10"
          xl="10"
          class="d-flex align-items-center justify-content-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            pills
            @change="handlePageChange"
            first-number
            last-number
          >
            <template #prev-text>
              <feather-icon size="18" icon="ChevronLeftIcon" />
            </template>
            <template #next-text>
              <feather-icon size="18" icon="ChevronRightIcon" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import _ from "lodash";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BToast,
  BSpinner,
  BBadge,
  VBTooltip,
  BTooltip,
  BFormSelect,
  BFormGroup,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import {
  allTicketsSupport,
  deleteTicketSupport,
  getCatalog,
  allEmployeesByCompany,
} from "@core/api/request";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";
import Filterss from "../components/filters/Filterss.vue";
import { canAccess } from "@/security/permissions/permissionHelper";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BToast,
    BSpinner,
    BBadge,
    BFormSelect,
    BFormGroup,
    BTooltip,
    Filterss,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data: () => ({
    model: "supports",
    companyGuid: null,
    loading: false,
    totalRows: null,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    striped: false,
    bordered: false,
    borderless: false,
    outlined: false,
    headVariant: "light",
    items: [],
    listStatus: [],
    listPriority: [],
    allEmployees: [],
    loadingEmployees: false,
    currentPageEmployees: 1,
    perPageEmployees: 100,
    totalPagesEmployees: null,
    hasNextPageEmployees: true,
    itemsPage: 1,
    itemsRows: 999,
    fields: [
      { label: "title", key: "title", sortable: true },
      { label: "description", key: "description", sortable: true },
      { label: "date-created", key: "dateCreated", sortable: true },
      { label: "name-status", key: "nameStatus", sortable: true },
      { label: "name-priority", key: "namePriority", sortable: true },
      { label: "name-employee", key: "nameEmployee", sortable: true },
      { label: "action", key: "actions", sortable: false },
    ],
    fieldsToFilters: [
      {
        name: "name",
        type: "text",
        placeholder: "name",
        type: "search",
        visible: true,
      },
      {
        name: "idEmployeeAssignedTo",
        title: "idEmployeeAssignedTo",
        placeholder: "idEmployeeAssignedTo",
        type: "select",
        options: [],
        visible: true,
        multiple: false,
        close: true,
      },
      {
        name: "idCatStatus",
        title: "idCatStatus",
        placeholder: "idCatStatus",
        type: "select",
        options: [],
        visible: true,
        multiple: false,
        close: true,
      },
      {
        name: "idCatPriority",
        title: "idCatPriority",
        placeholder: "idCatPriority",
        type: "select",
        options: [],
        visible: true,
        multiple: false,
        close: true,
      },
    ],
    appliedFilters: {},
  }),

  computed: {
    canCreate() {
      return canAccess("Tickets de soporte", "creation");
    },
    canShow() {
      return canAccess("Tickets de soporte", "reading");
    },
    canEdit() {
      return canAccess("Tickets de soporte", "edition");
    },
    canDelete() {
      return canAccess("Tickets de soporte", "elimination");
    },
  },
  mounted() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.loadAllTicketsSupport();
    this.loadCatData();
  },
  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
    },
  },
  methods: {
    label(field) {
      return `pages.supports.table.${field}`;
    },

    labelHeader(field) {
      return `pages.supports.table.tableHeader.${field}`;
    },

    tagsColor(tag) {
      if (tag === "Anual") return "light-success";
      if (tag === "Mensual") return "light-primary";
      if (tag === "Prueba gratuita") return "light-danger";
      return "light-warning";
    },

    chargeParams() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);

      arrParams.push(`rows,${this.perPage}`);

      return getParams(arrParams);
    },

    chargeParamsWithFilters() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);

      arrParams.push(`rows,${this.perPage}`);

      if (this.appliedFilters.name) {
        arrParams.push(`name,${this.appliedFilters.name}`);
      }

      if (this.appliedFilters.idEmployeeAssignedTo) {
        arrParams.push(
          `idEmployeeAssignedTo,${this.appliedFilters.idEmployeeAssignedTo}`,
        );
      }
      if (this.appliedFilters.idCatStatus) {
        arrParams.push(`idCatStatus,${this.appliedFilters.idCatStatus}`);
      }
      if (this.appliedFilters.idCatPriority) {
        arrParams.push(`idCatPriority,${this.appliedFilters.idCatPriority}`);
      }
      return getParams(arrParams);
    },
    chargeParamsCatalogs(key) {
      let arrParams = [];

      arrParams.push(`itemsPage,${this.itemsPage}`);

      arrParams.push(`itemsRows,${this.itemsRows}`);

      switch (key) {
        case "ticketSupportStatus":
          arrParams.push("guidCatalog, 0c98881d-eccb-44ac-876e-0d12f2ea9147");
          break;
        case "ticketSupportPriority":
          arrParams.push("guidCatalog, bdd918b2-a609-4777-b013-3109e87f5e1e");
          break;
      }

      return getParams(arrParams);
    },
    loadAllTicketsSupport() {
      const param = this.chargeParams();
      this.loading = !this.loading;
      allTicketsSupport(param)
        .then((resp) => {
          console.log("response", resp);
          const data = _.get(resp, "data");
          this.items = data?.items || [];
          this.totalRows = data?.totalRows || 0;
          this.loading = !this.loading;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },
    loadTickectSupportsWithFilters() {
      const param = this.chargeParamsWithFilters();
      this.loading = !this.loading;
      allTicketsSupport(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.items = data?.items || [];
          this.totalRows = data?.totalRows || 0;
          this.loading = !this.loading;
          if (resp.data == null) {
            this.alertToast(
              "danger",
              `Error`,
              `No se encontraron coincidencias`,
            );
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    handlePageChange(value) {
      // this.currentPage = value
      this.loadSubscriptions();
    },

    handlePerPageChange() {
      // Reset currentPage to 1 when changing perPage
      this.currentPage = 1;
      this.loadSubscriptions();
    },

    applyFilters(filters) {
      this.appliedFilters = filters;

      this.loadTickectSupportsWithFilters(filters);
    },
    resetFilters() {
      this.appliedFilters = {};

      this.loadAllTicketsSupport();
    },
    onCreate() {
      if (!this.canCreate) return;
      this.$router.push({
        name: "supportCreate",
        params: {
          option: 1, // option 1 to create
        },
      });
    },
    onShow(idSupplier) {
      if (!this.canShow) return;
      this.$router.push({
        name: "supportEdit",
        params: {
          option: 2, // option 2 to show
          idSupplier: idSupplier,
        },
      });
    },

    onEdit(idSupplier) {
      if (!this.canEdit) return;
      this.$router.push({
        name: "supportEdit",
        params: {
          option: 3, // option 3 to edit
          idSupplier: idSupplier,
        },
      });
    },

    onInfo() {},

    onDelete(guid) {
      if (!this.canDelete) return;
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("willNotBeAble"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yesDelete"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          showLoading();
          deleteTicketSupport(guid)
            .then((resp) => {
              stopLoading();

              const status = _.get(resp, "status");
              if (status == 500) {
                this.message(
                  this.$t("Alert"),
                  this.$t("registerHasntDeleted"),
                  "error",
                );
                return;
              }
              this.message(
                this.$t("Deleted"),
                this.$t("registerHasBeenDeleted"),
                "success",
              );
              this.loadAllTicketsSupport();
            })
            .catch((error) => {
              console.log("error", error);
              stopLoading();
              this.alertToast("danger", this.$t("codeAlert"), error.message);
            });
        } else if (result.dismiss === "cancel") {
          this.message(
            this.$t("canceled"),
            this.$t("registerDeletedCanceled"),
            "error",
          );
        }
      });
    },

    message(title, text, icon) {
      this.$swal({
        title,
        text,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
    async loadCatData() {
      showLoading();
      try {
        const paramTypeSub = this.chargeParamsCatalogs("ticketSupportStatus");
        const paramCoinTyps = this.chargeParamsCatalogs(
          "ticketSupportPriority",
        );
        const [resultStatus, resultPriority] = await Promise.all([
          getCatalog(paramTypeSub),
          getCatalog(paramCoinTyps),
        ]);
        await this.loadEmployeesByCompanie();
        stopLoading();
        this.listStatus = _.get(resultStatus, "data.listOfItems.items", []);
        this.listPriority = _.get(
          resultPriority,
          "data.listOfItems.items",
          [],
        );
        const transformedItemsListStatus = this.listStatus.map((item) => ({
          label: item.name,
          value: item.id,
        }));

        const transformedItemsListPriority = this.listPriority.map((item) => ({
          label: item.name,
          value: item.id,
        }));

        this.fieldsToFilters.forEach((element) => {
          if (element.name === "idCatStatus") {
            element.options = transformedItemsListStatus;
          }
          if (element.name === "idCatPriority") {
            element.options = transformedItemsListPriority;
          }
        });
      } catch (error) {
        console.log("error", error);
        stopLoading();
        this.alertToast("danger", `Alerta codigo`, error.message);
      }
    },
    chargeParamsEmployees() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPageEmployees}`);

      arrParams.push(`rows,${this.perPageEmployees}`);

      arrParams.push(`guidCompany,${this.companyGuid}`);
      if (this.searchClients != null)
        arrParams.push(`name,${this.searchClients}`);
      arrParams.push(`active,${true}`);

      return getParams(arrParams);
    },
    async loadEmployeesByCompanie() {
      if (this.loadingEmployees || !this.hasNextPageEmployees) return;

      this.loadingEmployees = true;
      const param = this.chargeParamsEmployees();
      await allEmployeesByCompany(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          if (data != null) {
            const employees = Array.isArray(data.items) ? data.items : [];
            this.allEmployees = [...this.allEmployees, ...employees];
            this.currentPageEmployees = data?.currentPage;
            this.totalPagesEmployees = data?.totalPages || 0;
            this.hasNextPageEmployees =
              this.currentPageEmployees < this.totalPagesEmployees;

            const transformedItemsListEmployees = this.allEmployees.map(
              (item) => ({
                label: item.name,
                value: item.idEmployee,
              }),
            );

            this.fieldsToFilters.forEach((element) => {
              if (element.name === "idEmployeeAssignedTo") {
                element.options = transformedItemsListEmployees;
              }
            });
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.hasNextPageEmployees = false;
        })
        .finally(() => {
          this.loadingEmployees = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
